import { useTranslation } from 'react-i18next'

import { PressCard } from './PressCard'
import { PRESS_ITEMS } from './pressItems'
import { SectionHeader } from './SectionHeader'
import styles from './PressRail.module.scss'

/**
 * A horizontal scroller, the way the parent site runs it: cards keep one width and the row overflows
 * rather than reflowing, so the rail reads as "there is more" at every viewport.
 */
export const PressRail = () => {
  const { t } = useTranslation()

  return (
    <section id="media" className={styles.root}>
      <SectionHeader kicker={t('landing.press.kicker')} title={t('landing.press.title')} />
      <div className={styles.rail}>
        {PRESS_ITEMS.map((item) => (
          <PressCard key={item.href} item={item} />
        ))}
      </div>
    </section>
  )
}
